import { Dimensions32ju1l7z4mh as Dimension } from '../models/data.mjs';
import { Edges2jf5wl855ambv as Edges } from '../models/Rect.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import {
  mapsbvh18eqox7a as map,
  toListx6x8nvfmvvht as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  reversed22y3au42jl32b as reversed,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_padding(_this__u8e3s4, value) {
  var tmp;
  var tmp_0 = value;
  if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
    tmp = null;
  } else {
    var tmp_1 = value;
    // Inline function 'kotlin.let' call
    var p0 = (tmp_1 == null ? null : new (Dimension())(tmp_1)).value_1;
    tmp = Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(p0);
  }
  _this__u8e3s4.set_paddingByEdge_53g79y_k$(tmp);
}
function get_padding(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_paddingByEdge_29dw58_k$();
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.left_1;
}
function get_theme(_this__u8e3s4) {
  return _this__u8e3s4.get_themeAndBack_k3yag2_k$().theme_1;
}
function viewPath(_this__u8e3s4) {
  var tmp = generateSequence(_this__u8e3s4, viewPath$lambda);
  return joinToString(reversed(toList(map(tmp, viewPath$lambda_0))), '/');
}
function viewPath$lambda(it) {
  return it.get_parent_hy4reb_k$();
}
function viewPath$lambda_0(element) {
  var tmp0_elvis_lhs = element.get_debugName_58dolx_k$();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = element.get_parent_hy4reb_k$();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_children_4cwbp4_k$();
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.indexOf_si1fv9_k$(element);
    tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp4_elvis_lhs = tmp;
  var id = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = getKClassFromExpression(element).get_simpleName_r6f8py_k$();
  var type = tmp5_elvis_lhs == null ? 'anonymous' : tmp5_elvis_lhs;
  return id + ':' + type;
}
//region block: exports
export {
  get_padding as get_padding2xbtedaunn69u,
  set_padding as set_padding5v7ifiir6y9y,
  get_theme as get_theme90wn9glxu60a,
  viewPath as viewPath22j8rl3x6zdx1,
};
//endregion

//# sourceMappingURL=Element.ext.mjs.map
